<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
        this.initProvince();
		this.handleGetAuthList();
		this.promiseAll();

	},
	data() {
		return {
			authOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					authStatus: '',
					queryTimeBegin: '',
					queryTimeEnd: '',
                    letterTypeId: '',
                    letterAgencyId: '',
                    // provinceId: '',
                    // cityId: '',
                    mobile: ''
				},
			},
			selectOption: {
				authStatus: [],
                provinceId: [],
                cityId: [],
                letterTypeId: [],
                // followTypeId: []
			},
			codeDetail: {},
			dialogOption: {
				width: '40%',
				title: '项目编辑',
				type: 1, // 0新增， 1编辑
				show: false
			}
		}
	},
	methods: {
        initProvince() {
            this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
        },
		// 获取选择项
        promiseAll() {
            Promise.all([this.letterType(), this.followType()]).then(res => {
                this.selectOption.letterTypeId = res[0].data || [];
                this.selectOption.authStatus = res[1].data || [];
            });
        },
		handleDelete(row){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            })
		},
		handleEdit(row, type, title) {
			this.codeDetail = row;
			this.dialogOption.type = type;
			this.dialogOption.title = title;
			this.dialogOption.show = true;
			this.$nextTick(()=> {
				this.$refs.edit.modelStatus(true);
			});
		},
		async handleGetAuthList() {
			this.$loading(true);
			const {pageQuery, searchQuery} = this.authOption;
			const {pageSize, currentPage}  = pageQuery;
            // resourceListUrl
			try {
				const {code, data} = await this.getLetterList({
					...searchQuery, pageSize, currentPage
				});
				this.authOption.data = data && data.dataSource || [];
				this.authOption.pageQuery.total = data && data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		initCodePage() {
			console.log(1112);
		},
		skipPage({id}) {
			this.$router.push({
				path: `/policy/bid/bidDetail/${id}`,
				query: {
					event: 'getReleaseBid'
				}
			})
		},
        change({value, type}) {
			this.authOption.pageQuery.currentPage = 1;
			if (type && Object.is(type, 'provinceId')) {
				this.authOption.searchQuery.cityId = '';
				this.selectOption.cityId = this.setCity(value);
			}
            if (type && Object.is(type, 'oneTradeId')) {
				this.authOption.searchQuery.twoTradeId = '';
				this.selectOption.twoTradeId = this.setTrade(value);
			}
		},
		setCity(val) {
			return this.cityList.filter(item => item.parentId === val);
		},
        setTrade(val) {
            const list = this.selectOption.oneTradeId.filter(item => item.tradeId === val);
			return val ? list[0].childTrade : [];
		},
		...mapActions('zft',['getLetterList', 'updateLetter', 'purInfoType',
		'letterType', 'followType'])
	},
	computed: {
		...mapGetters('zft', ['cityList']),
		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	},
    watch: {
		'cityList': function() {
			this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
		}
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar
	  :handlerCodeSearch="handleGetAuthList"
	  :searchQuery="authOption.searchQuery"
	  :selectOption="selectOption"
	  @change="change"
	></top-bar>
    <code-table
     :data="authOption.data"
     :columns="columns.letterColumns"
     :searchEvent="handleGetAuthList"
     :pageOptions="authOption.pageQuery"
    >

		<el-table-column label="项目标题" align="center" slot="title" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
				<span class="active" @click="skipPage(scope.row)">{{scope.row.title}}</span>
	        </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="70" slot="operate">
            <template slot-scope="scope">
	            <el-button type="success"  @click="handleEdit(scope.row, 2, '跟进')">跟进</el-button>
	        </template>
        </el-table-column>
    </code-table>
    <edit ref="edit"
	  :dialogOption="dialogOption"
	  :codeEvent="updateLetter"
	  :searchEvent="handleGetAuthList"
	  :codeDetail="codeDetail"
	  :selectOption="selectOption"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
